import { Turret } from "./Turret";
import { Engine } from "../Engine";
import { GameConstants } from "../GameConstants";
import { Enemy } from "../enemies/Enemy";

export class TeleportTurret extends Turret {

    public intensity: number;
    public teleportDistance: number;
    public duration: number;
    public durationTicks: number;

    constructor (p: {r: number, c: number}, engine: Engine, skipBuild?: boolean, level?: number) {
        
        super(GameConstants.TURRET_TELEPORT, p, engine, skipBuild, level);

        this.teleportDistance = 0;

        this.projectileSpeed = GameConstants.ARROW_SPEED;

        this.calculateTurretParameters();
    }

    // mirar en el ANUTO y generar las formulas que correspondan
    protected calculateTurretParameters(): void {

        this.teleportDistance = this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_TELEPORT_DISTANCE][this.level - 1];
        this.reload = this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_RELOAD][this.level - 1];
        this.range = this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_RANGE][this.level - 1];
        this.priceUpgrade = this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_PRICE_UPGRADE][this.level - 1];

        super.calculateTurretParameters();
    }

    protected shoot(): void {
        
        super.shoot();

        let enemy: Enemy;

        if (this.fixedTarget) {
            enemy = this.followedEnemy || this.enemiesWithinRange[0];
        } else {
            enemy = this.enemiesWithinRange[0];
        }
         
        this.engine.flagEnemyToTeleport(enemy, this);
    }
}
